import { Input } from '@lt/components';
import { Cross, SearchLoader } from '@lt/components/icons-react';
import { Search } from '@lt/components/icons-react/userflow';
import React from 'react';
import styled, { keyframes } from 'styled-components';

type Props = {
  onClick?: () => void;
  isFilterPopup?: boolean;
  className?: string;
  onChange?: (value: string) => void;
  isFetching?: boolean;
  hotelName?: string;
  handleWipeButtonClicked?: () => void;
  inputRef?: React.RefObject<HTMLInputElement>;
  placeholderText: string;
};

const FilterInput = ({
  placeholderText,
  onClick,
  isFilterPopup,
  className,
  onChange,
  isFetching,
  hotelName,
  handleWipeButtonClicked,
  inputRef,
}: Props): JSX.Element => (
  <StyledContainer className={className}>
    <StyledInput
      placeholder={placeholderText}
      onClick={onClick}
      value={hotelName}
      reference={inputRef}
      onChange={(e) => onChange?.(e.target.value)}
    />
    {isFetching ? <StyledSearchLoader /> : <StyledLoupe />}
    {isFilterPopup && <StyledSlideCross onClick={handleWipeButtonClicked} />}
  </StyledContainer>
);

const StyledContainer = styled.div`
  position: relative;
  width: 100%;
`;

const StyledInput = styled(Input)`
  border-radius: 4px;
  width: -webkit-fill-available;
  width: -moz-available;
  height: 48px;
  padding: 16px 8px 16px 35px;
  display: flex;
  align-items: center;
  gap: 4px;
  border-color: #919499;
  font-size: 16px;
  font-weight: 700;
  &::placeholder {
    font-size: 16px;
    font-weight: 400;
    color: #919499;
  }
`;

const StyledLoupe = styled(Search)`
  stroke: #919499;
  width: 24px;
  height: 24px;
  position: absolute;
  top: 12px;
  left: 8px;
`;

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const StyledSearchLoader = styled(SearchLoader)`
  width: 24px;
  height: 24px;
  animation: ${spin} 0.5s linear infinite;
  position: absolute;
  top: 12px;
  left: 8px;
`;

const StyledSlideCross = styled(Cross)`
  width: 24px;
  height: 24px;
  position: absolute;
  right: 8px;
  top: 12px;
  > path {
    fill: #919499;
  }
`;

export default FilterInput;
